import { Col, Row } from "react-bootstrap";

import { Chapter } from "../../components/Chapter";
import React from "react";
import {
  useParams
} from "react-router-dom";

export const Wines = () => {

  let { nome } = useParams();
  React.useEffect(() => {
    if (nome) {
      const ele = document.getElementById(nome);
      const navHeight = window.innerHeight * 0.15;
      window.scrollTo(ele.offsetLeft, ele.offsetTop - navHeight);
    }
  },)

  const chapters = [
    {
      name: "sialic",
      title: "Sialic: Deep Roots Among the Sialitic Rocks",
      text: "Our Sialic is a white wine that comes from our homonymous Sauvignon Blanc vineyard. This wine embodies the beauty of natural simplicity, with the roots of the vines deeply intertwined in the underlying sialitic rocks, allowing the grapes to fully express the unique terroir of our vineyard. The Sauvignon Blanc grapes are carefully harvested and vinified using the white winemaking method, preserving the freshness and vitality of the variety. The result is a wine that captures the purity of the grapes and the fruity notes that characterize Sauvignon.<br>It is a wine that celebrates the beauty of simplicity and the extraordinary complexity that can emerge from a respectful approach towards the grape and the terroir.<br>Every glass of Sialic is a journey into freshness and authenticity, an experience that celebrates the unmistakable character of our vineyards.",
      image: "/images/wines/sialic doc.png",
      buttons: [
        {
          link: "/en/sialic/20182019",
          bText: '2018-2019'
        },
        {
          link: "/en/sialic/2020",
          bText: '2020'
        },
        {
          link: "/en/sialic/2021",
          bText: '2021'
        }]
    },
    {
      name: "sialicesperienzadibotte",
      title: "Sialic Esperienza di Botte: A Journey of Evolution",
      text: "Sialic Esperienza di Botte is a truly unique interpretation of our Sauvignon Blanc. In this expressive wine, both fermentation and the subsequent aging take place inside a small oak barrel. This process allows the wine to rest gently on its lees in wood for about a year, gaining unique depth and complexity.<br>During this aging period, the wine embarks on a transformation journey where the wood adds subtle but significant nuances to its aromas and flavors. This barrel aging experience gives our Sauvignon Blanc a unique character, a surprising balance between fruity freshness and slightly vanilla and toasted notes.",
      image: "/images/wines/sialic esperienza di botte.png",
      buttons: [{
        link: "/en/sialicesperienzadibotte/2020",
        bText: '2020'
      }]
    },
    {
      name: "sialicespressionidibucce",
      title: "Sialic Espressioni di Bucce: Secrets Revealed",
      text: "Sialic Espressioni di Bucce is a fascinating and bold reinterpretation of our Sauvignon Blanc. The grape skins join the must in a brief yet intense dance, imparting all their secrets of aromatic and structural complexity to the must.<br>This brief skin maceration imparts depth of character to the future wine, making it stand out in an exceptional way. The flavors and aromas that emerge from this skin maceration are surprising, creating a wine that challenges expectations and enchants the palate. Sialic Espressione di Bucce is an authentic sensory exploration, a unique experience in every sip.",
      image: "/images/wines/sialic espressioni di bucce.png",
      buttons: [{
        link: "/en/sialicespressionidibucce/2022",
        bText: '2022'
      }]
    },
    {
      name: "bram",
      title: "Bram: Harmonic Elegance of the International and the Local",
      text: "Bram is a wonderful combination of the international Pinot Noir grape and the rich local winemaking culture. The grapes, harvested at perfect maturity, are vinified using the submerged cap method, revealing fruity, spicy, and earthy nuances that harmonize with the distinctive character of the soil.<br>The nobility of the grape variety blends with the local identity, perfectly integrating and giving the wine tannins and color. Time is the ally that reveals the true essence of this wine. After vinification, Bram ages for one or two years in small oak barrels and then in glass, allowing the wine to reach its full expression.<br>Every bottle tells the story of the integration between tradition and innovation, a testament to the passion and care we dedicate to the production of our wines. This wine reveals our commitment to offering unforgettable tasting experiences.",
      image: "/images/wines/bram doc.png",
      buttons: [
        {
          link: "/en/bramprimipassi/2020",
          bText: '2019'
        },
        {
          link: "/en/bram/2020",
          bText: '2020'
        },
        {
          link: "/en/bram/2021",
          bText: '2021'
        }]
    },
    {
      name: "brichet",
      title: "Brichet: A Journey Through Time and Flavors",
      text: "Our Brichet wine is the result of a skilled blend of different red and white grape varieties, each carefully selected to bring its unique personality to the wine. This combination of grapes offers a bouquet of fresh and enticing flavors.<br>Testament to our pride and winemaking heritage, this wine celebrates a historic vineyard where tradition and innovation blend into a symphony of flavors and aromas.<br>Every sip of Brichet embodies the essence of our land and the love we invest in every bottle. A journey through time and flavors that connects us to our roots.",
      image: "/images/wines/brichet.png",
      buttons: [
        {
          link: "/en/brichet/19841995",
          bText: '1984-1995'
        },
        {
          link: "/en/brichet/2021",
          bText: '2021'
        },
       {
          link: "/en/brichet/2022",
          bText: '2022'
        }]
    },
    {
      name: "tan",
      title: "Tan: The Art of the Land Without Compromise",
      text: "Tan represents the pure essence of local winemaking art. This wine is produced from a wide variety of grapevines from the same vineyard, harvested with the utmost care and vinified using traditional methods passed down through generations. The wine undergoes no clarification or filtration, but naturally decants under the influence of time and climate during its two-year aging in barrels. This approach allows the wine to maintain a robust structure and complexity that reflects the pristine terroir from which it comes.<br>With a tasting that connects you to the centuries-old winemaking traditions of this region, this wine is a tribute to the farming experience, the pride of the land, and the love for viticulture. An authentic winemaking recipe without compromise, a heritage we are honored to share.",
      image: "/images/wines/tan.png",
      buttons: [{
        link: "/en/tan/2020",
        bText: '2020'
      }]
    },
  ];

  return (
    <>
      <Row>
        <Col md={12} className="text-center">
          <h2>
            Our Wines: Stories in Bottles of Past, Present and Future
          </h2>
        </Col>
      </Row>
      {chapters.map((chapter, index) => (
        <Chapter key={index} chapter={chapter} index={index} newPage={false} />
      ))}
    </>
  );
};
